import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin } from 'lucide-react';
import { openCookieSettings } from './CookieConsent';

const contactRows = [
  { label: 'Email', value: 'experience@empaxstudio.com', href: 'mailto:experience@empaxstudio.com' },
  { label: 'Vijay Sabhlok', value: '+91 98200 24469', href: 'tel:+919820024469' },
  { label: 'Tanya Jain', value: '+91 62644 58176', href: 'tel:+916264458176' },
  { label: 'Studio', value: 'Mumbai, India', href: null },
];

const socials = [
  { label: 'Instagram', Icon: Instagram, href: 'https://www.instagram.com/empactstudio?igsh=MTE2aGg4N29wbm15cQ%3D%3D&utm_source=qr' },
  { label: 'LinkedIn', Icon: Linkedin, href: 'https://www.linkedin.com/company/empactstudio/' },
  { label: 'Facebook', Icon: Facebook, href: 'https://www.facebook.com/people/Empact-Studio/61577340200570/' },
];

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="relative border-t border-[var(--border)]" style={{ backgroundColor: '#0d122a' }}>
    <div className="max-w-[1500px] mx-auto px-6 md:px-10 pt-[var(--section-pad)] pb-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10 items-start">
        {/* Column 1 - logo + socials */}
        <div className="flex flex-col items-start gap-7">
          <Link to="/" aria-label="Empax Studio home">
            <img src="/empax-logo.png" alt="Empax Studio" className="h-16 w-auto" />
          </Link>
          <div className="flex items-center gap-4">
            {socials.map(({ label, Icon, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="w-11 h-11 rounded-full border border-[var(--border-strong)] flex items-center justify-center text-[var(--muted)] hover:text-[#0A0D17] hover:bg-[var(--accent)] hover:border-[var(--accent)] transition-all duration-300"
              >
                <Icon size={18} strokeWidth={1.6} />
              </a>
            ))}
          </div>
        </div>

        {/* Column 2 - legal links */}
        <div className="flex flex-col items-start gap-5 md:pt-2">
          <span className="label !text-[var(--muted-2)] mb-1">Legal</span>
          <Link to="/privacy" data-testid="footer-privacy-link" className="nav-link font-mono text-[var(--text)] hover-gold transition-colors">Privacy &amp; Cookie Policy</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="nav-link font-mono text-[var(--text)] hover-gold transition-colors">Terms of Use</Link>
          <button type="button" onClick={openCookieSettings} data-testid="footer-cookie-settings" className="nav-link font-mono text-[var(--text)] hover-gold transition-colors text-left">Cookie Settings</button>
        </div>

        {/* Column 3 - contact details */}
        <div className="flex flex-col items-start gap-6">
          {contactRows.map((r) => (
            <div key={r.label} className="flex flex-col items-start">
              <span className="label mb-1">{r.label}</span>
              {r.href ? (
                <a href={r.href} className="nav-link font-mono text-[var(--text)] hover-gold transition-colors">{r.value}</a>
              ) : (
                <span className="font-mono text-[var(--text)]">{r.value}</span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar - company name, centered */}
      <div className="mt-14 pt-8 border-t border-[var(--border)] text-left md:text-center">
        <span className="label !text-[var(--muted-2)] block w-full text-center !tracking-normal leading-[1.6] text-[clamp(0.58rem,2.4vw,0.72rem)]" data-testid="footer-company">© {new Date().getFullYear()} Empax Studio &amp; Experiences Pvt. Ltd.<br />All rights reserved.</span>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
